<div class="mat-elevation-z8">
  <table mat-table class="full-width-table" matSort aria-label="Elements">
    <!-- Id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>

    <!--  Template Column -->
    <ng-container matColumnDef="template">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Template</th>
      <td mat-cell *matCellDef="let row">
        {{ getTemplateName(row.template_id) }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <!-- Phone Column -->
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
      <td mat-cell *matCellDef="let row">{{ row.phone }}</td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let row">
        {{ row.status || "Probably an Error" }}
      </td>
    </ng-container>

    <!-- Updated Column -->
    <ng-container matColumnDef="updated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
      <td mat-cell *matCellDef="let row">{{ row.updated | date: "short" }}</td>
    </ng-container>

    <!-- Sent By Column -->
    <ng-container matColumnDef="sent_by">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent By</th>
      <td mat-cell *matCellDef="let row">
        {{ row.sent_by?.replace("@life.local", "") }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    #paginator
    [length]="dataSource?.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[25, 50, 100, 250]"
    [pageIndex]="index"
    (page)="onPageChange.emit($event)"
  >
  </mat-paginator>
</div>
